import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="text-center space-y-6">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 360]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="w-16 h-16 relative mx-auto"
        >
          {/* Pokeball design */}
          <div className="absolute inset-0 rounded-full border-4 border-white"></div>
          <div className="absolute inset-0 border-t-4 border-red-500 rounded-full animate-spin"></div>
          <div className="absolute inset-[25%] rounded-full bg-white"></div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="space-y-2"
        >
          <h2 className="text-xl font-pokemon text-white">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500">
              Loading...
            </span>
          </h2>
          <p className="text-gray-400 text-sm">Catching some Pokemon cards</p>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingScreen; 